import i18n, { LANGUAGE_STORAGE_KEY } from 'i18n';

export const syncDocumentLanguage = (language: string): void => {
  document.documentElement.lang = language;
};

const changeLanguage = async (language: string): Promise<void> => {
  await i18n.changeLanguage(language);

  try {
    window.localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
  } catch {
    // Safari private mode — the choice just will not persist.
  }

  syncDocumentLanguage(language);
};

export default changeLanguage;
